// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BaZE","inner":"styles_inner__2xGh_","right":"styles_right__10LIc","close":"styles_close__3dMV4","footer":"styles_footer__2o2gg"};